import type { RouterOutputs } from '@package/api'

import type { LessonModuleModalData } from '../../components/lesson-module-modal'

export function mapToLessonModuleModalData(
  details: RouterOutputs['lesson']['getLessonModuleDetails'] & { type: 'lessonModule' },
): LessonModuleModalData {
  return {
    id: details.id,
    title: details.title,
    learningFocus: details.learningFocus,
    coverUrl: details.coverUrl,
    estimatedTimeMinutes: details.estimatedTimeMinutes,
    grade: details.grade,
    curricula: details.curricula,
    contributors: details.contributors,
    lessons: details.lessons,
  }
}
